import React from "react";
import styles from "./Directory.module.css";
import Button from "../../../components/common/Button";

const residentsData = [
  { id: 1, name: "Rahul Sharma", flat: "A-204, Block A", phone: "9876543210", initials: "RS", colorClass: styles.bgGreen },
  { id: 2, name: "Priya Verma", flat: "B-101, Block B", phone: "9876543211", initials: "PV", colorClass: styles.bgBlue },
  { id: 3, name: "Amit Patel", flat: "A-308, Block A", phone: "9876543212", initials: "AP", colorClass: styles.bgOrange },
  { id: 4, name: "Neha Singh", flat: "C-201, Block C", phone: "9876543213", initials: "NS", colorClass: styles.bgPurple },
  { id: 5, name: "Vikram Joshi", flat: "B-302, Block B", phone: "9876543214", initials: "VJ", colorClass: styles.bgGray },
];

const Directory = () => {
  return (
    <div className={styles.directoryContainer}>
      
      {/* Background Decorative Leaves */}
      <svg className={styles.bgLeafLeft} viewBox="0 0 200 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 50C50 50 100 100 100 200C100 300 50 350 0 350" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M0 100C40 100 80 140 80 200C80 260 40 300 0 300" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M0 150C30 150 60 170 60 200C60 230 30 250 0 250" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M40 100C70 70 120 70 150 100C150 100 120 120 100 200" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M70 160C110 130 150 140 180 170C180 170 140 180 100 200" stroke="#E0E8E2" strokeWidth="2"/>
      </svg>
      <svg className={styles.bgLeafRight} viewBox="0 0 200 400" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M0 50C50 50 100 100 100 200C100 300 50 350 0 350" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M0 100C40 100 80 140 80 200C80 260 40 300 0 300" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M0 150C30 150 60 170 60 200C60 230 30 250 0 250" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M40 100C70 70 120 70 150 100C150 100 120 120 100 200" stroke="#E0E8E2" strokeWidth="2"/>
        <path d="M70 160C110 130 150 140 180 170C180 170 140 180 100 200" stroke="#E0E8E2" strokeWidth="2"/>
      </svg>

      <div className={styles.contentWrapper}>
        <div className={styles.headerSection}>
          <div className={styles.headerText}>
            <div className={styles.pillBadge}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
              Our Community
            </div>
            <h1 className={styles.pageTitle}>Resident Directory</h1>
            <p className={styles.leadText}>Connect with your neighbors.</p>
          </div>
          <div className={styles.headerIllustration}>
            <svg viewBox="0 0 400 120" fill="none" stroke="#A9C7B5" strokeWidth="1.5">
              <path d="M0 110h400" strokeWidth="2"/>
              <path d="M50 110V70l20-20 20 20v40M130 110V50h40v60M200 110V40h50v70M290 110V60h30v50M350 110V30h40v80" fill="#E6EFEB" stroke="none"/>
              <path d="M50 110V70l20-20 20 20v40M130 110V50h40v60M200 110V40h50v70M290 110V60h30v50M350 110V30h40v80" />
              <rect x="140" y="60" width="8" height="10" />
              <rect x="140" y="80" width="8" height="10" />
              <rect x="215" y="55" width="8" height="10" />
              <rect x="215" y="75" width="8" height="10" />
              <rect x="215" y="95" width="8" height="10" />
              <path d="M100 110a20 20 0 0 1 20-20 20 20 0 0 1 20 20" fill="#D3E4D9" stroke="none"/>
              <path d="M100 110a20 20 0 0 1 20-20 20 20 0 0 1 20 20" />
              <path d="M30 110a15 15 0 0 1 15-15 15 15 0 0 1 15 15" />
              <path d="M260 110a25 25 0 0 1 25-25 25 25 0 0 1 25 25" fill="#D3E4D9" stroke="none"/>
              <path d="M260 110a25 25 0 0 1 25-25 25 25 0 0 1 25 25" />
              <circle cx="340" cy="20" r="15" fill="#FDF1E8" stroke="none"/>
              <path d="M300 40c5-5 10-5 15 0" />
              <path d="M280 20c5-5 10-5 15 0" />
            </svg>
          </div>
        </div>

        <div className={styles.searchSection}>
          <div className={styles.searchBox}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
            <input type="text" placeholder="Search by name, flat no., mobile..." className={styles.searchInput} />
          </div>
          <select className={styles.blockSelect}>
            <option>All Blocks</option>
            <option>Block A</option>
            <option>Block B</option>
            <option>Block C</option>
          </select>
        </div>

        <div className={styles.residentsList}>
          {residentsData.map(resident => (
            <div key={resident.id} className={styles.residentCard}>
              <div className={styles.residentInfo}>
                <div className={`${styles.avatar} ${resident.colorClass}`}>
                  {resident.initials}
                </div>
                <div className={styles.details}>
                  <h3 className={styles.name}>{resident.name}</h3>
                  <p className={styles.flat}>{resident.flat}</p>
                </div>
              </div>
              <div className={styles.contactInfo}>
                <span className={styles.phone}>{resident.phone}</span>
                <button className={styles.callBtn} aria-label="Call">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z"></path></svg>
                </button>
              </div>
            </div>
          ))}
        </div>

        <div className={styles.viewAllWrapper}>
          <button className={styles.primaryBtn}>
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path><circle cx="9" cy="7" r="4"></circle><path d="M23 21v-2a4 4 0 0 0-3-3.87"></path><path d="M16 3.13a4 4 0 0 1 0 7.75"></path></svg>
            View All Residents
          </button>
        </div>
      </div>
    </div>
  );
};

export default Directory;
